import { calculateQuoteOrderTotals, OrderTableData } from '@teinor/erp/prices/quote/totals'
import { HeaderDataCalculate } from '@teinor/erp/types/company/order/general'
import { getConfigParam } from '../../../../utils/reducers/getters'

export const parseOrderTableData = (tableData: OrderTableData, headerData: HeaderDataCalculate) => {
    const orderAddAddonsUnitFooterTotal = getConfigParam('orderAddAddonsUnitFooterTotal') === 'off' ? false : true
    const orderAddAddonsWeightFooterTotal = getConfigParam('orderAddAddonsWeightFooterTotal') === 'off' ? false : true
    
    const taxResult = calculateQuoteOrderTotals(tableData, headerData, { orderAddAddonsUnitFooterTotal, orderAddAddonsWeightFooterTotal })
    return taxResult
}